<template>
  <div class="video-time">{{ duration > 0 ? time : '视频'}}</div>
</template>

<script>

export default {
  name: 'video-time',
  props: {
    // 秒
    duration: {
      default: 0,
    },
  },
  computed: {
    time() {
      const add0 = num => (num >= 0 && num < 10 ? '0' : '') + num;
      const s = this.duration % 60;
      const m = (this.duration - s) / 60 % 60;
      const h = (this.duration - s - m * 60) / 60 / 60;
      return (h > 0 ? `${add0(h)}:` : '') + `${add0(m)}:${add0(m)}`;
    },
  }
}
</script>

<style scoped>
.video-time{
  padding: 0 4px;
  background-color: #000000;
  color: #FFFFFF;
  height: 14px;
  line-height: 14px;
  font-size: 10px;
  border-radius: 7px;
  opacity: 0.8;
}
</style>
